"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsByMachine = getProductsByMachine;
async function getProductsByMachine(machineRepo, id) {
    return await machineRepo.getProductsByMachine(id);
}
